import React, { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import trans from 'translate';
import { getSaftsAction } from '../../../../../redux/actions/createHPoolActions';
import { toggleModal } from '../../../../../redux/actions/modalActions';
import { Button } from '../../../../Common';
import Icon from '../../../../Common/Icon/Icon';
import ShowAt from '../../../../Common/ShowAt/ShowAt';
import { ADD_PROJECT_MODAL } from '../../../../Modals/modalTypes';
import PoolProject from './PoolProject/PoolProject';
import './ProjectsTable.scss';
import SkeletonWrapper from '../../../../hoc/SkeletonWrapper/SkeletonWrapper';

export default function ProjectsTable() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [renderedProjects, setRenderedProjects] = useState(3);
  const showMore = () => setRenderedProjects((c) => c + 3);

  const createPhase = useMemo(() => location.pathname.includes('create'), [location.pathname]);
  const { saftsInfo, poolId } = useSelector((state) => ({
    saftsInfo: state?.createHPool?.poolSafts,
    poolId: state?.createHPool?.hpool.id,
  }));

  const { loading, saftsArray } = saftsInfo;

  const openProjectsModal = (saftInfo) => {
    const modalProps = { className: 'form-action-modal', width: 800, saftInfo, refreshSafts: getSaftsAction };
    dispatch(toggleModal(ADD_PROJECT_MODAL, modalProps, true));
  };

  const hasSafts = !!saftsArray?.length;

  useEffect(() => {
    if (poolId) dispatch(getSaftsAction(poolId));
  }, [poolId]);

  const sliceShownProjects = (records = []) => records.slice(0, renderedProjects - 1);

  return (
    <div className="projects">
      <ShowAt at={!createPhase}>
        <div className="projects-header">
          <span className="projects-header-title">Projects Table</span>
          <button onClick={() => openProjectsModal()} type="button" className="button green projects-header-button">
            {trans('pools.add_token')}
          </button>
        </div>
      </ShowAt>
      <div className={clsx('projects-wrapper', { 'no-border': !createPhase })}>
        <SkeletonWrapper wrapperClass="projects-wrapper-skeletons" loading={loading} count={3} minHeight="13vh">
          {sliceShownProjects(saftsArray).map((saft) => (
            <PoolProject onEdit={openProjectsModal} key={saft?.token_symbol} {...saft} />
          ))}
        </SkeletonWrapper>
        <ShowAt at={renderedProjects <= saftsArray.length}>
          <div className="projects-show-more" onClick={showMore}>
            <span className="projects-show-more-text">Show all tokens</span>
            <Icon name="show-more" />
          </div>
        </ShowAt>
        <ShowAt at={!loading}>
          <Button
            onClick={() => openProjectsModal()}
            className={clsx('add-project-btn outlined-btn', { filled: hasSafts })}
            text="pools.add_token"
          />
        </ShowAt>
      </div>
    </div>
  );
}
